import { useEffect } from "react";
import { useSelector } from "react-redux";
import { datadogRum } from "@datadog/browser-rum";
import {
  getEmail,
  getName,
  getId,
  getActualUuid,
} from "../selectors/selectors";

/**
 * Custom hook to automatically sync Redux user state with Datadog RUM user tracking
 * This ensures user information is consistently tracked across the application
 * @returns {object} User data from Redux store containing email, name, id, and uuid
 */
export const useDatadogUser = () => {
  const email = useSelector(getEmail);
  const name = useSelector(getName);
  const id = useSelector(getId);
  const uuid = useSelector(getActualUuid);

  useEffect(() => {
    // Only update Datadog user if we have at least an email
    if (email) {
      const userData: any = { email };

      // Add additional user data if available
      if (name) userData.name = name;
      if (id) userData.id = id;
      if (uuid) userData.uuid = uuid;

      datadogRum.setUser(userData);
    }
  }, [email, name, id, uuid]);

  return {
    email,
    name,
    id,
    uuid,
  };
};

export default useDatadogUser;
